var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 10.8307H11.3332V14.9974C11.3332 15.2184 11.2454 15.4304 11.0891 15.5867C10.9328 15.7429 10.7209 15.8307 10.4998 15.8307C10.2788 15.8307 10.0669 15.7429 9.91058 15.5867C9.7543 15.4304 9.6665 15.2184 9.6665 14.9974V10.8307H5.49984C5.27882 10.8307 5.06686 10.7429 4.91058 10.5867C4.7543 10.4304 4.6665 10.2184 4.6665 9.9974C4.6665 9.77638 4.7543 9.56442 4.91058 9.40814C5.06686 9.25186 5.27882 9.16406 5.49984 9.16406H9.6665V4.9974C9.6665 4.77638 9.7543 4.56442 9.91058 4.40814C10.0669 4.25186 10.2788 4.16406 10.4998 4.16406C10.7209 4.16406 10.9328 4.25186 11.0891 4.40814C11.2454 4.56442 11.3332 4.77638 11.3332 4.9974V9.16406H15.4998C15.7209 9.16406 15.9328 9.25186 16.0891 9.40814C16.2454 9.56442 16.3332 9.77638 16.3332 9.9974C16.3332 10.2184 16.2454 10.4304 16.0891 10.5867C15.9328 10.7429 15.7209 10.8307 15.4998 10.8307Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPrimary);
export default __webpack_public_path__ + "static/media/AddPrimary.faeb31a09a2d657ce202f43490f61dd4.svg";
export { ForwardRef as ReactComponent };